import * as React from "react";
import {
  Create,
  SimpleForm,
  SelectInput,
  required,
  ReferenceInput,
  AutocompleteInput,
  useGetList,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";
import Merchants from "./merchants.js";

const GasBrands = () => {
  const { data: images } = useGetList("File");

  const renderOptionText = (record) => {
    const [logo] = images.filter((image) => {
      if (record.logo_file_id === image.id) {
        return image;
      }
    });

    return (
      <span key={record.id}>
        <img
          src={logo?.url}
          width={15}
          height={15}
          style={{ marginRight: "5px" }}
        />
        {record.name}
      </span>
    );
  };

  return (
    <ReferenceInput source="gas_brand_id" reference="GasBrand">
      <AutocompleteInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        inputText={(record) => record.name}
        optionText={renderOptionText}
        optionValue="id"
        debounce={10}
        validate={[required()]}
        filterToQuery={(searchText) => ({ name: searchText })}
      />
    </ReferenceInput>
  );
};

const createGasBrandMerchant = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record?.url}
        alt={record.name}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <Create redirect="show">
      <SimpleForm toolbar={<CustomToolbar />}>
        <GasBrands />
        {plugins &&
          nonDefaultClientRequires.some((plugin) => plugin === true) &&
          Merchants[merchant].CreateGasBrandMerchant()}
        <ReferenceInput source="logo_file_id" reference="File">
          <AutocompleteInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            inputText={(record) => record.name}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        <SelectInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          validate={[required()]}
          choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => {
            if (status === "blocked") {
              return "";
            }

            return {
              id: status,
              name: `resources.GasBrandMerchant.source.status.${status}`,
            };
          })}
        />
      </SimpleForm>
    </Create>
  );
};

export default createGasBrandMerchant;
